import setAppPaneUnderlayVisibility from 'owa-application/lib/actions/setAppPaneUnderlayVisibility';
import { lazyHideFlexPane } from 'owa-flex-pane';
import { lazyTriggerResizeEvent } from 'owa-resize-event';

export const ADDIN_TASK_PANE_KEY = 'addinTaskPane';

export function expandPaneUnderlay() {
    setAppPaneUnderlayVisibility(ADDIN_TASK_PANE_KEY, true, false);
    lazyTriggerResizeEvent.importAndExecute();
    lazyHideFlexPane.importAndExecute();
}

export function collapsePaneUnderlay() {
    setAppPaneUnderlayVisibility(ADDIN_TASK_PANE_KEY, false, false);
    lazyTriggerResizeEvent.importAndExecute();
}
